import { CountryContext, LocaleContext } from 'Components/hooks/context';
import React, { useContext } from 'react';

import AtlasMetadataClient from '@reuters-graphics/graphics-atlas-client';
import Link from 'next/link';
import { component } from './styles.module.scss';
import getLanguage from 'Utils/getLocales/getLanguage';
const atlas = new AtlasMetadataClient();

const getLink = (locale, activeLocale, country) => {
  return locale === 'en' ? (
    <Link href='/countries-and-territories/[country]' as={`/countries-and-territories/${country.slug}`} key={locale}>
      <a
        className={activeLocale === locale ? 'active' : ''}
      >{getLanguage(locale)}
      </a>
    </Link>
  ) : (
    <Link href='/[locale]/countries-and-territories/[country]' as={`/${locale}/countries-and-territories/${country.slug}`} key={locale}>
      <a
        className={activeLocale === locale ? 'active' : ''}
      >{getLanguage(locale)}
      </a>
    </Link>
  );
};

const LocaleLinks = (props) => {
  const { locales } = props;
  const activeLocale = useContext(LocaleContext);
  const countryCode = useContext(CountryContext);
  if (!locales.includes('en')) locales.unshift('en');

  const country = atlas.getCountry(countryCode);

  const links = locales.map(locale => getLink(locale, activeLocale, country));

  return (
    <div className={`${component} font-sans`}>
      {links}
    </div>
  );
};

export default LocaleLinks;
